import { useFileUpload } from "../../hooks/file/useFileUpload";
import React from "react";

type FileUploadProps = {
  storagePath: string;
  fileName?: string;
  label?: string;
  accept?: string;
  autoUpload?: boolean;
  onStart?: () => void;
  onProgress?: (progress?: number) => void;
  onSuccess?: (downloadURL: string) => void;
  onError?: (error: Error) => void;
  transformFile?: (file: File) => Promise<File>;
  onClickButton?: () => void;
};

const FileUpload: React.FC<FileUploadProps> = ({
  storagePath,
  label,
  accept,
  fileName,
  autoUpload,
  onStart,
  onProgress,
  onSuccess,
  onError,
  transformFile,
  onClickButton,
}: FileUploadProps) => {
  const {
    file,
    isUploading,
    error,
    downloadURL,
    handleFileChange,
    uploadFile,
  } = useFileUpload({
    storagePath,
    fileName,
    autoUpload,
    onStart,
    onProgress,
    onError,
    onSuccess,
    transformFile,
  });

  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <button
        onClick={handleButtonClick}
        style={{ display: "flex", alignItems: "center" }}
      >
        {label || "파일 선택"}
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        style={{ display: "none" }} // hide input
        onChange={handleFileChange}
      />
      {file && !autoUpload && (
        <div>
          <p>선택된 파일: {file.name}</p>
          {!isUploading && <button onClick={() => uploadFile()}>업로드</button>}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
